export default __webpack_public_path__ + "static/media/placeholder-home (1).cb0f8b91.png";